/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";

import logo from "../../assets/mytutor-logo.svg";

const Logo = () => (
    <a href="/">
        <img
            css={css`
                width: 92px;
                height: 24px;
                align-self: center;
            `}
            src={logo}
            alt="MyTutor logo"
        />
    </a>
);

export default Logo;
